<template>
  <div
    class="cell cell-header"
    :style="{
      width: currentWidth ? `${currentWidth}px` : '',
      'z-index': resizing ? '2800 !important' : '',
    }"
    :class="{ 'cell-edit': editable && changeable }"
    :contenteditable="editable && changeable"
    @keydown.enter="enter"
    @mouseover="hover"
    @mouseleave="leave"
    @blur="change"
    @focus="select"
    @keydown.enter.prevent="enter"
    @keydown.esc.prevent.stop="goBack"
  >
    <div>{{ $t(displayName) }}</div>
  </div>
</template>

<script>
  export default {
    name: 'HeaderCell',
    props: {
      editable: {
        type: Boolean,
        default: false,
      },
      changeable: {
        type: Boolean,
        default: false,
      },
      resizable: {
        type: Boolean,
        default: false,
      },
      name: {
        type: String,
        required: true,
      },
      field: {
        type: Object,
        required: false,
      },
      currency: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        focus: false,
        hoverCell: false,
        cellWidth: null,
        resizing: false,
        timeout: false,
        initResizeX: null,
        val: this.name,
        newVal: null,
        currentWidth: this.field.width.pixels || null,
        initialWidth: this.field.width.pixels || null,
      };
    },
    computed: {
      displayName() {
        if (this.name.match(/untitled[0-9]+/i)) return 'untitled';
        else return this.name + `${this.field?.showCurrency ? `, ${this.currency}` : ''}`;
      },
    },
    watch: {
      field(updated) {
        this.initialWidth = updated.width.pixels;
        this.currentWidth = updated.width.pixels;
      },
    },
    mounted() {
      window.addEventListener('mouseup', this.stopResize);
      window.addEventListener('mousemove', (e) => this.move(e));
    },
    methods: {
      initResize(e) {
        this.resizing = true;
        this.initResizeX = e.x;
      },
      stopResize() {
        this.resizing = false;
        this.initResizeX = null;
        this.initialWidth = this.field?.width?.pixels || null;
        this.currentWidth = this.field?.width?.pixels || null;
      },
      move(e) {
        if (this.resizing) {
          this.currentWidth = this.initialWidth - (this.initResizeX - e.x);
          if (!this.timeout) {
            this.timeout = true;
            setTimeout(() => {
              this.timeout = false;
            }, 500);
            if (e.x > this.initResizeX) {
              this.$emit('make-wider');
            } else {
              this.$emit('make-narrower');
            }
          }
        }
      },
      hover() {
        if (this.editable && this.changeable) {
          this.hoverCell = true;
        }
      },
      leave() {
        this.hoverCell = false;
      },
      select() {
        if (!this.editable) return;
        this.focus = true;
        this.newVal = this.val.trim();
      },
      enter(e) {
        this.focus = false;
        e.target.blur();
      },
      change(e) {
        this.focus = false;
        const val = e.target.firstChild.textContent.trim();
        if (e.target.firstChild && val !== this.val) this.$emit('change', val, e);
      },
      goBack(e) {
        if (this.newVal) {
          e.target.firstChild.textContent = this.newVal;
          this.val = this.newVal;
        }
        this.newVal = null;
        e.target.blur();
      },
    },
  };
</script>
